if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      /*
       * The "custom text" and "logo/image upload" fields (rendered by the
       * "additinal_field" block in sections/main-product.liquid) are NOT
       * inside this <product-form> element - they live in the product info
       * column and are linked to the <form> only through the HTML
       * form="{{ product_form_id }}" attribute. That's why we look them up
       * on the whole document and filter by matching form id, instead of
       * using this.querySelector().
       */
      getCustomFields() {
        return Array.from(
          document.querySelectorAll("[data-custom-field-input]")
        ).filter((field) => field.getAttribute("form") === this.form.id);
      }

      validateCustomFields() {
        let isValid = true;
        let firstInvalidField = null;

        this.getCustomFields().forEach((field) => {
          const isRequired = field.hasAttribute("data-custom-field-required");
          const isFile = field.hasAttribute("data-custom-file-input");
          const errorSelector = isFile
            ? "[data-custom-file-error]"
            : "[data-custom-text-error]";
          const wrapper = field.closest(".input__field_form");
          const errorEl = wrapper
            ? wrapper.querySelector(errorSelector)
            : null;

          let fieldIsValid = true;

          if (isRequired) {
            if (isFile) {
              fieldIsValid = field.files && field.files.length > 0;
            } else {
              fieldIsValid = field.value.trim().length > 0;
            }
          }

          if (errorEl) {
            errorEl.textContent = fieldIsValid
              ? ""
              : field.dataset.errorMessage ||
                (isFile
                  ? "Please upload a file before adding this product to your cart."
                  : "Please fill in this field before adding this product to your cart.");
            errorEl.toggleAttribute("hidden", fieldIsValid);
          }

          wrapper?.classList.toggle("input__field_form--invalid", !fieldIsValid);

          if (!fieldIsValid) {
            isValid = false;
            firstInvalidField = firstInvalidField || field;
          }
        });

        if (firstInvalidField) {
          firstInvalidField.focus();
        }

        return isValid;
      }

      onSubmitHandler(evt) {
        if (!this.validateCustomFields()) {
          evt.preventDefault();
          this.handleErrorMessage(
            "Please complete the required customization fields before adding this product to your cart."
          );
          return;
        }

        /*
         * Shopify's AJAX endpoint (/cart/add.js) does not upload files - it
         * only receives the browser's fake local path string
         * (C:\fakepath\logo.png). Real file uploads to Shopify's CDN only
         * happen on a full, native browser POST to /cart/add (multipart
         * form submission with a real page load/redirect). So if a file is
         * attached, we deliberately do NOT preventDefault() / fetch() here -
         * we let the <form> submit natively instead.
         */
        const hasFileUpload = this.getCustomFields().some(
          (field) =>
            field.hasAttribute("data-custom-file-input") &&
            field.files &&
            field.files.length > 0
        );

        if (hasFileUpload) {
          // Native submit: browser handles the multipart POST + redirect to /cart.
          return;
        }

        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);

        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            console.log(parsedState)
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              return;
            }
            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }
            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }
            document
              .querySelector(".product-form__error-message-wrapper")
              ?.classList.add("no-js-inline");

            // Reset the customization fields + previews after a successful add
            this.getCustomFields().forEach((field) => {
              field.value = "";
              const wrapper = field.closest(".input__field_form");
              wrapper?.classList.remove("input__field_form--invalid");
              const preview = wrapper?.querySelector(
                "[data-custom-file-preview]"
              );
              if (preview) {
                preview.hidden = true;
                const img = preview.querySelector(
                  "[data-custom-file-preview-image]"
                );
                const name = preview.querySelector(
                  "[data-custom-file-preview-name]"
                );
                if (img) {
                  img.hidden = true;
                  img.src = "";
                }
                if (name) name.textContent = "";
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}

/*
 * Live preview + clear-on-error behaviour for the "logo / image upload" and
 * "custom text" fields added by the "additinal_field" block. This is wired
 * up with document-level event delegation because the fields sit outside
 * the <product-form> custom element (see comment above).
 */
(function () {
  function initCustomFieldPreview(fileInput) {
    const wrapper = fileInput.closest(".input__field_form--file");
    if (!wrapper) return;

    const preview = wrapper.querySelector("[data-custom-file-preview]");
    const previewImage = wrapper.querySelector(
      "[data-custom-file-preview-image]"
    );
    const previewName = wrapper.querySelector(
      "[data-custom-file-preview-name]"
    );
    const removeButton = wrapper.querySelector("[data-custom-file-remove]");
    const errorEl = wrapper.querySelector("[data-custom-file-error]");

    fileInput.addEventListener("change", () => {
      const file = fileInput.files && fileInput.files[0];

      if (errorEl) errorEl.hidden = true;
      wrapper.classList.remove("input__field_form--invalid");

      if (!file) {
        preview.hidden = true;
        return;
      }

      previewName.textContent = file.name;

      if (file.type && file.type.startsWith("image/")) {
        previewImage.src = URL.createObjectURL(file);
        previewImage.hidden = false;
      } else {
        previewImage.hidden = true;
        previewImage.removeAttribute("src");
      }

      preview.hidden = false;
    });

    removeButton?.addEventListener("click", () => {
      fileInput.value = "";
      preview.hidden = true;
      previewImage.hidden = true;
      previewImage.removeAttribute("src");
      previewName.textContent = "";
    });
  }

  function initCustomTextField(textInput) {
    const wrapper = textInput.closest(".input__field_form");
    if (!wrapper) return;
    const errorEl = wrapper.querySelector("[data-custom-text-error]");

    textInput.addEventListener("input", () => {
      if (textInput.value.trim().length > 0 && errorEl) {
        errorEl.hidden = true;
        wrapper.classList.remove("input__field_form--invalid");
      }
    });
  }

  document
    .querySelectorAll("[data-custom-file-input]")
    .forEach(initCustomFieldPreview);
  document
    .querySelectorAll(
      "[data-custom-field-input]:not([data-custom-file-input])"
    )
    .forEach(initCustomTextField);
})();